import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CrudModel, CrudService, RequestParams} from '@ngx-ivengi/crud';
import {ContactService} from './contact.service';
import {Contact} from './contact.model';
import {UIRouter} from '@uirouter/angular';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-entity-contact-form',
  templateUrl: './entity-contact-form.component.html'
})
export class EntityContactFormComponent implements OnInit, OnDestroy {
  @Input() public crudService: CrudService<CrudModel>;

  public entityType: string;
  public selectedEntity: CrudModel;
  public selectedContact: Contact;
  public entities: CrudModel[] = [];
  public contacts: Contact[] = [];
  private requestParams: RequestParams = new RequestParams();
  private alreadyLinkedContacts;

  constructor(
    private contactService: ContactService,
    private router: UIRouter
  ) {}

  public ngOnInit(): void {

    if(this.crudService) {
      this.entityType = this.crudService.entityType.name.toLowerCase();

      const requestParams = new RequestParams();
      requestParams.addFilterParam({
        id: 0,
        key: 'type',
        operator: 'eq',
        value: this.entityType.toUpperCase()
      }).pagination.limit = 0;

      this.contactService.clearRoutePrefix();
      this.contactService.setRoutePrefix(`assignment/${this.router.stateService.params.assignmentId}`);
      this.contactService.getAll(requestParams).subscribe((contacts) => {
        this.alreadyLinkedContacts = contacts.map((contact) => {
          return contact.contactId;
        });
      });



      this.requestParams.pagination.limit = 0;

      this.crudService.getAll(this.requestParams).map((entities: any) => {
        return entities.filter((item) => {
          return (item.contactCount > 0);
        });
      }).subscribe((entities) => {
        this.entities = entities;
      });
    }
  }

  public onEntitySelect() {
    this.contactService.clearRoutePrefix();
    this.contactService.setRoutePrefix(`${this.entityType}/${this.selectedEntity.id}`);
    this.contactService.getAll(this.requestParams).subscribe((contacts: Contact[]) => {
      this.contacts = contacts.filter((item) => {
        return (this.alreadyLinkedContacts.indexOf(item.id) === -1);
      });

      // by default, select first
      this.selectedContact = this.contacts[0] || null;
    });
  }

  public ngOnDestroy(): void {
    this.contactService.clearRoutePrefix();
  }

  public save(): void {
    this.contactService.clearRoutePrefix();
    this.contactService.setRoutePrefix(`assignment/${this.router.stateService.params.assignmentId}`);
    this.selectedContact.setType(this.crudService.entityType.name.toUpperCase());
    this.contactService.add(this.selectedContact).subscribe((response) => {
      const currentState = this.router.stateService.$current.name;
      const currentStateParts = currentState.split('.');
      currentStateParts.pop();
      const parentState = currentStateParts.join('.');
      this.router.stateService.go(parentState, this.router.stateService.params, {reload: true});
    });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/contact/entity-contact-form.component.ts